function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M.5 6.5l10 5.774V.726L.5 6.5zm9 1h11v-2h-11v2z",
  fill: "#039BE8"
});

var SvgArrowBackBig = function SvgArrowBackBig(props) {
  return React.createElement("svg", _extends({
    width: 21,
    height: 13,
    viewBox: "0 0 21 13",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml,%3Csvg width='21' height='13' viewBox='0 0 21 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M0.5 6.5L10.5 12.2735V0.726497L0.5 6.5ZM9.5 7.5H20.5V5.5H9.5V7.5Z' fill='%23039BE8'/%3E %3C/svg%3E";
export { SvgArrowBackBig as ReactComponent };